import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=16db751b&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=16db751b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db751b",
  null
  
)

export default component.exports